/** Read the CSRF double-submit cookie set by the backend session endpoint. */
export function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)tozen_csrf=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}
